import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'Sofía',
  location: 'Florida',
  time: 'Hace 5 minutos'
}, {
  name: 'Andrea',
  location: 'Texas',
  time: 'Hace 12 minutos'
}, {
  name: 'Valentina',
  location: 'California',
  time: 'Hace 18 minutos'
}, {
  name: 'Camila',
  location: 'New York',
  time: 'Hace 23 minutos'
}, {
  name: 'Lucía',
  location: 'Illinois',
  time: 'Hace 31 minutos'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimer = setTimeout(() => {
      setVisible(true);
    }, 5000);
    return () => clearTimeout(showTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex(prev => (prev + 1) % notifications.length);
        setVisible(true);
      }, 8000);
    }, 6000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed, index]);
  const current = notifications[index];
  const handleClose = () => {
    setVisible(false);
    setDismissed(true);
  };
  return <AnimatePresence data-id="element-172">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 20,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-[calc(100vw-2rem)] sm:w-auto" data-id="element-173">
          <div className="bg-white rounded-xl shadow-lg border border-slate-100 p-3 flex items-center gap-3 relative" data-id="element-174">
            <button onClick={handleClose} className="absolute top-2 right-2 text-slate-300 hover:text-slate-500 transition-colors" data-id="element-175">
              <X className="w-3.5 h-3.5" data-id="element-176" />
            </button>

            <img src="https://cdn.magicpatterns.com/uploads/4UGZKsbaeP1PBFAdCGaDyz/MOCKUP_COMPRIMIDO.png" alt="Calma en Casa" className="w-12 h-12 rounded-lg object-cover shrink-0" data-id="element-177" />

            <div className="pr-4" data-id="element-178">
              <p className="font-sans text-sm text-brand-navy leading-snug" data-id="element-179">
                <span className="font-bold" data-id="element-180">{current.name}</span> de{' '}
                {current.location} acaba de comprar la guía{' '}
                <span className="font-bold" data-id="element-181">Calma en Casa</span>
              </p>
              <p className="font-sans text-xs text-slate-400 mt-0.5" data-id="element-182">
                {current.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}